import React, { useState, useEffect, useCallback, useReducer } from 'react'
import { StyleSheet, Text, View, Button, Platform, Alert, ActivityIndicator, KeyboardAvoidingView } from 'react-native'
import { ScrollView } from 'react-native-gesture-handler';
import { StatusBar } from 'expo-status-bar';
import Card from '../components/Card';
import Input from '../components/Input';
import * as WebBrowser from 'expo-web-browser';
import { HeaderButtons, Item} from 'react-navigation-header-buttons';
import HeaderButton from '../components/HeaderButton';
import { useDispatch } from 'react-redux';
import * as authActions from '../store/authActions'

const FORM_INPUT_UPDATE = 'FORM_INPUT_UPDATE';

const formReducer = (state, action) => {
    if (action.type === FORM_INPUT_UPDATE) {
      const updatedValues = {
        ...state.inputValues,
        [action.input]: action.value
      };
      const updatedValidities = {
        ...state.inputValidities,
        [action.input]: action.isValid
      };
      let updatedFormIsValid = true;
      for (const key in updatedValidities) {
        updatedFormIsValid = updatedFormIsValid && updatedValidities[key];
      }
      return {
        formIsValid: updatedFormIsValid,
        inputValidities: updatedValidities,
        inputValues: updatedValues
      };
    }
    return state;
};



const SignupScreen = props => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState();
    const dispatch = useDispatch();
    const refPassword = React.createRef();
    const refPasswordRepeat = React.createRef();

    const [formState, dispatchFormState] = useReducer(formReducer, {
        inputValues: {
          email: '',
          password: '',
          repeatPassword: ''
        },
        inputValidities: {
          email: false,
          password: false,
          repeatPassword: false
        },
        formIsValid: false
    });

    const signUpHandler = useCallback(async () => {
        if (!formState.formIsValid) {
            Alert.alert('Wrong input', 'Please check the errors in the form.', [
              { text: 'OK'}
            ]);
            return;
          }
        setError(null);
        setIsLoading(true);
        try {
            await dispatch(authActions.signup(formState.inputValues.email, formState.inputValues.password));
            props.navigation.navigate({routeName: 'Main', key: 'Main', params: { userEmail: formState.inputValues.email}});
        } catch (err) {
          setError(err.message)
          setIsLoading(false)
        }      
    }, [dispatch, formState])

    useEffect(() => {
        props.navigation.setParams({ info: openBrowser });
      }, [openBrowser]);

    const openBrowser = () => {
        WebBrowser.openBrowserAsync('https://fromhereafter.online/landing.php', {controlsColor: '#404040'});
      };

    const inputChangeHandler = useCallback((inputIdentifier, inputValue, inputValidity) => {
        dispatchFormState({
          type: FORM_INPUT_UPDATE,
          value: inputValue,
          isValid: inputValidity,
          input: inputIdentifier
        });
      },
      [dispatchFormState]
    );

    return (
      <KeyboardAvoidingView style={{flex:1}} contentContainerStyle={{flex:1}} behavior="padding" keyboardVerticalOffset={Platform.OS === 'android' ? -220 : -120}>
          <ScrollView>
            <View style={styles.scrollview}>
            <StatusBar style="auto" />
              <View style={styles.titleContainer}><Text style={styles.title}>Sign Up For</Text><Text style={styles.title}>Fromhereafter</Text></View>
              {error && <Card style={styles.errorContainer}>
                 <Text style={styles.errorText}>{error}</Text>
            </Card>}
              <Card style={styles.formContainer}>
                <Input
                        id="email"
                        label="Email address"
                        errorText="Please enter a valid email address"
                        keyboardType="email-address"
                        autoCapitalize="none"
                        autoCorrect={false}
                        returnKeyType="next"
                        textContentType="emailAddress"
                        onInputChange={inputChangeHandler}
                        required
                        email
                        placeholder="Email"
                        onSubmitEditing={() => { refPassword.current.focus(); }}
                        blurOnSubmit={false}
                    />
                    <Input
                        id="password"
                        label="Password"
                        errorText="A valid password must have at least 8 characters, one uppercase and lowercase letter, one digit and one special character"
                        keyboardType="default"
                        autoCapitalize="none"
                        autoCorrect={false}
                        returnKeyType="next"
                        textContentType="newPassword"
                        secureTextEntry
                        onInputChange={inputChangeHandler}
                        required
                        placeholder="Password"
                        isPassword
                        onSubmitEditing={() => { refPasswordRepeat.current.focus(); }}
                        ref={refPassword}
                        blurOnSubmit={false}
                    />
                    <Input
                        id="repeatPassword"
                        label="Repeat Password"
                        errorText="Passwords do not match"
                        keyboardType="default"
                        autoCapitalize="none"
                        autoCorrect={false}
                        returnKeyType="go"
                        textContentType="newPassword"
                        secureTextEntry
                        onInputChange={inputChangeHandler}
                        required
                        placeholder="Repeat Password"
                        repeatPassword={formState.inputValues.password}
                        ref={refPasswordRepeat}
                        onSubmitEditing={signUpHandler}
                    />
                <View style={{margin: 10}}>
                  {isLoading 
                  ? <ActivityIndicator size='small' color='#404040' />
                  :<Button title="Sign Up" color='#404040' onPress={signUpHandler} />}
                </View>
              </Card>
                <View style={styles.descriptionContainer}>
                    <Text>Signing up is free. Signing up means that you will be able to store a message, secret or password on this website. As long as you confirm you are still alive, your message stays with us. We will send this message to the email address you have entered when you are not able to confirm that you are alive. No information you share on this app will be shared with anyone other than you yourself or the person that you mention to us.</Text></View>
              </View>
            </ScrollView>     
          </KeyboardAvoidingView>          
    )
}

SignupScreen.navigationOptions = navData => {
    const openBrowserfn = navData.navigation.getParam('info')
    if (Platform.OS === 'web') {
      return {
        headerTitle: 'Sign Up'
      }
    }
    return {
        headerTitle: 'Sign Up',
        headerRight: (() =>
        <HeaderButtons HeaderButtonComponent={HeaderButton}>
          <Item
            title="Logout"
            iconName={
              Platform.OS === 'ios' ? 'ios-information-circle-outline' : 'md-information-circle-outline'
            }
            onPress={openBrowserfn}
          />
        </HeaderButtons>
      )
    }   
}

export default SignupScreen;

const styles = StyleSheet.create({
    screen: {
        flex: 1,
    },
    scrollview: {
        flex: 1,
        alignItems: 'center',
        padding: 10
    },
    title: {
      fontSize: 32,
      fontWeight: "bold"
    },
    titleContainer: {
        alignItems: 'center',
        marginBottom: 10,
        width: '100%',
    },
    formContainer: {
        width: '90%',
        marginBottom: 25,
        paddingHorizontal: 20,
        maxWidth: 500
    },
    descriptionContainer: {
        width: '90%',
        maxWidth: 500
    },
    errorContainer: {
      width: '90%',
      padding: 5,
      alignItems: 'center',
      marginBottom: 10,
      maxWidth: 500
    },
    errorText: {
      color: '#d9534f',
      fontSize: 13,
    }
})
